/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { PanelResizeHandle } from 'react-resizable-panels';
import type { PanelResizeHandleProps } from 'react-resizable-panels';

import { MoreVerticalFilledIcon } from 'bundles/ai-course-coach/assets/mui';

type SplitPanelResizeHandleProps = Omit<PanelResizeHandleProps, 'children' | 'style'>;

const styles = {
  resizeHandle: css`
    position: relative;
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-inline: 1px solid var(--neutral-stroke-primary-weak, #e5e7e8);
    border-right-width: 0;
    color: var(--cds-color-grey-600);
    background-color: var(--cds-color-neutral-background-primary-weak);
    transition: color 0.2s;

    /* Vertical line on hover */
    ::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 2px;
      height: 100%;
      background-color: var(--cds-color-feedback-informative);
      opacity: 0;
      transition: opacity 0.2s;
    }

    :hover::before,
    :focus::before {
      opacity: 1;
    }

    /* Extend interactive area with ::after */
    ::after {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 8px;
      height: 100%;
      z-index: 2;
    }
  `,
};

const SplitPanelResizeHandle = (props: SplitPanelResizeHandleProps) => (
  <PanelResizeHandle {...props} css={styles.resizeHandle}>
    <MoreVerticalFilledIcon size={16} />
  </PanelResizeHandle>
);

export default SplitPanelResizeHandle;
